
<template>
	<v-container id="reservationsContainer" fluid="fluid" class="mpa-0 pa-4">
		<v-layout row wrap>
			<reservations-table
				@showReservation="showReservation"
				@showUnit="showUnit"
				@showUser="showUser"
				@dataLoaded="dataLoaded"
				ref="reservationsTable"
				:filter="active"
			></reservations-table>
			<v-btn fixed dark fab bottom right color="pink" @click="newReservation()">
				<v-icon>add</v-icon>
			</v-btn>
		</v-layout>
		<user-modal
			:id="userId"
			:edit="editUser"
			:user="editUser"
			ref="userModal"
			:showSelector="showUserSelector"
			@userUpdated="$refs.reservationsTable.getReservations(true, true)"
		></user-modal>
		<reservations-modal
			:id="reservation.id"
			:edit="editReservation"
			:reservation="reservation"
			:units="units"
			ref="reservationModal"
			@newUser="newUser()"
			@copyReservation="copyReservation($event)"
		></reservations-modal>
		<new-reservation-modal
			:id="reservation.id"
			:edit="newReservationData"
			:units="units"
			ref="newReservationModal"
			@update="showReservation($event)"
			@newUser="newUser()"
		></new-reservation-modal>
		<unit-modal
			:id="editUnit.id"
			:edit="editUnit"
			:selectedUnit="editUnit"
			:new="false"
		></unit-modal>
	</v-container>
</template>
<script>
import ReservationsTable from '@/components/Reservations/ReservationsTable';
import UserModal from '@/components/Users/UserModal';
import NewReservationModal from '@/components/Reservations/NewReservationModal';
import UnitModal from '@/components/Units/UnitModal';
import * as utils from '@/utils/utils';
import moment from 'moment';

export default {
	name: 'Reservations',
	components: {
		UserModal,
		NewReservationModal,
		ReservationsTable,
		UnitModal
	},
	data() {
		return {
			user: {
				edit: false
			},
			reservation: {},
			unit: {},
			editReservation: {
				startTime: '00:00',
				endTime: '00:00',
				showModal: false
			},
			newReservationData: {
				showModal: false,
				startDate: '',
				endDate: '',
				startTime: '00:00',
				endTime: '00:00',
				discount: 0,
				costData: {
					prices: [],
					additionalItems: []
				}
			},
			src: '',
			editUser: {
				showModal: false
			},
			edit: {
				showModal: false
			},
			active: null,
			editUnit: {
				showModal: false,
				id: 0
			},
			units: [],
			userId: -1,
			showReservationModal: false,
			showUserSelector: true
		};
	},
	mounted() {
		var self = this;
		window.emitter.$off('newUser');
		window.emitter.$on('newUser', function() {
			self.newUser();
		});

		if (this.$route.params.id) {
			this.showReservation({ id: this.$route.params.id });
		}
	},
	watch: {
		$route(to, from) {
			this.showReservation({ id: to.params.id });
		}
	},
	methods: {
		dataLoaded() {},
		getUnits() {
			var self = this;
			if (!self.units.length) {
				utils
					.getData(basePath + 'api/rentunits/getSimpleUnitList')
					.then(function(response) {
						self.units = response.data;
					});
			}
		},
		showUser(userId) {
			this.userId = userId;
			this.showUserSelector = false;
			this.editUser.showModal = true;
		},
		showReservation(reservation) {
			this.getUnits();
			this.$refs.reservationModal.showReservation(reservation.id);
			return false;
		},
		newReservation() {
			this.getUnits();
			this.$refs.newReservationModal.initReservation();
		},
		newUser() {
			this.$refs.userModal.newUser();
		},
		showUnit(unit) {
			this.editUnit.showModal = true;
			this.editUnit.unitId = unit.id;
			this.editUnit.id = unit.id;
			unit.edit = true;
			this.newUnit = false;
		},
		copyReservation(reservation) {
			let diff = moment(reservation.endDate).diff(
				moment(reservation.startDate),
				'months'
			);
			let newEndDate = moment(reservation.endDate)
				.add(diff, 'months')
				.format('YYYY-MM-DD');
			this.$refs.newReservationModal.openModalWithData(
				reservation.endDate,
				reservation.endTime,
				newEndDate,
				reservation.endTime,
				reservation.unitId,
				reservation.user_id,
				reservation
			);
		}
	}
};
</script>
<style lang="scss">
.tabs__content > .card {
	min-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Reservations/Reservations.vue